import { defaultLanguage } from "../constants";
import { Country, Language } from "../types";

const defaultCultureFormatLength = "xx-xx".length;

const getCountryAndCulture = (countries: Country[], culture: string) => {
    let country: Country | undefined = undefined;
    let countryCulture: Language | undefined = undefined;

    let countryMatch: Country | undefined = undefined;

    //Non dstv.com sites like media sales
    if (culture.length !== defaultCultureFormatLength && !culture.includes("-")) {
        countryMatch = countries.find(x => culture === x.countryCode);
    }

    //English culture
    else if (culture.startsWith(defaultLanguage)) {
        countryMatch = countries.find(x => culture === `${defaultLanguage}-${x.countryCode}`);
    }

    //Look for non English language in countries with multiple languages
    else {
        const multiLingualCountries = countries.filter(x => x.languages.length);

        for (const multiLingualCountry of multiLingualCountries) {
            const languageMatch = multiLingualCountry.languages.find(x => x.culture === culture);

            if (languageMatch) {
                country = multiLingualCountry;
                countryCulture = languageMatch;
                country.url = languageMatch.url; //update the country URL to the language-specific URL
                break;
            }
        }
    }

    if (!!countryMatch) {
        country = countryMatch;
        countryCulture = {
            code: countryMatch?.countryCode
            , culture: culture,
            url: `/${culture}`
        } as Language;
    }

    if (!country) {
        country = countries[0];
    }

    return {
        country,
        countryCulture
    };
}

export default getCountryAndCulture;
